<template>
  <div class="mit-maps-page mit-page">
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">
            <v-card-title>Maps</v-card-title>
            <v-card-subtitle class="caption">CSAIL Maps Information</v-card-subtitle>
            <v-divider></v-divider>
            
            <v-card-text class="d-flex flex-column align-center justify-center text-center py-12">
              <v-icon size="80" color="primary" class="mb-6">mdi-map-marker-path</v-icon>
              
              <h2 class="text-h4 text--primary mb-4 font-weight-medium">
                Navigate CSAIL
              </h2>
              
              <p class="text-subtitle-1 mb-8" style="max-width: 600px; line-height: 1.6;">
                Explore CSAIL facilities, search for rooms, lab groups, or equipment, and get accessible indoor turn-by-turn directions.
              </p>
              
              <v-btn
                large
                elevation="2"
                color="primary"
                href="https://maps.csail.mit.edu/home"
                target="_blank"
              >
                Launch Maps Application
                <v-icon right dark>mdi-open-in-new</v-icon>
              </v-btn>
            </v-card-text>
            
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  export default {
    name: 'MitMapsPage',
    components: {},
    data: function() {
      return {}
    }
  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width: 100%;
    min-height: 60vh; /* Ensures the centered content has room to breathe */
  }
</style>